import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { appConfig } from './app.config';

import Keycloak from 'keycloak-js';
import { environment } from './environments/environment';

import { ApplicationConfig, APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function initI18nFactory(translate: TranslateService) {
    return () => new Promise<void>((resolve) => {
        const lang = localStorage.getItem('lang') || 'it';
        translate.addLangs(['it', 'en']);
        translate.setDefaultLang('it');
        translate.use(lang).subscribe({ next: () => resolve(), error: () => resolve() });
    });
}

async function main() {
    const keycloak = new Keycloak({
        url: environment.loginUrl,
        realm: environment.keyCloakRealm,
        clientId: environment.keyCloakClientId
    });

    await keycloak.init({
        onLoad: environment.keyCloakOnLoad as 'login-required' | 'check-sso',
        checkLoginIframe: false,
        pkceMethod: 'S256',
        redirectUri: environment.afterLoginRedirect,
    });

    const runtimeConfig: ApplicationConfig = {
        ...appConfig,
        providers: [
            ...(appConfig.providers ?? []),
            provideHttpClient(withInterceptorsFromDi()),
            importProvidersFrom(
                TranslateModule.forRoot({
                    loader: {
                        provide: TranslateLoader,
                        useClass: TranslateHttpLoader,
                        deps: [HttpClient]
                    }
                })
            ),
            { provide: APP_INITIALIZER, multi: true, useFactory: initI18nFactory, deps: [TranslateService] },
            { provide: Keycloak, useValue: keycloak },
        ],
    };

    await bootstrapApplication(AppComponent, runtimeConfig);
}
main();
